import { ZigZagType } from "../../types/mainModulTypes"
import PrimaryButton from "../common/PrimaryButton"
import { API } from "../../constants/constants"
import { useNavigate } from "react-router-dom"
import BaseHeadline from "../common/BaseHeadline"
import BaseSubheadline from "../common/BaseSubheadline"
import BaseRichtext from "../common/BaseRichtext"

export default function ZigZag(props: ZigZagType) {


    const getWidth = (width?: string): string => {
        if (width?.includes("zigZagImageWidth40")) return "md:w-[calc(40%-1rem)]"
        if (width?.includes("zigZagImageWidth50")) return "md:w-[calc(50%-1rem)]"
        if (width?.includes("zigZagImageWidth60")) return "md:w-[calc(60%-1rem)]"
        return ""
    }

    const getAlignment = (alignment?: string): string => {
        if (alignment?.includes("zigZagImageAlignmentVertical")) return "aspect-[3/4]"
        if (alignment?.includes("zigZagImageAlignmentSquare")) return "aspect-square"
        if (alignment?.includes("zigZagImageAlignmentHorizontal")) return "aspect-[4/3]"
        return ""
    }

    const navigate = useNavigate()

    return (
        <div
            className={`max-w-content  px-4 lg:px-0  flex-col flex gap-4 sm:gap-8 items-center mx-auto ${
                props?.zigZagImageToggle ? "md:flex-row-reverse" : "md:flex-row"
            }`}>
            <img
                src={API + props.zigZagImage?.url}
                alt={props.zigZagImage?.description}
                className={`w-full ${getWidth(props.zigZagImageWidth)} ${getAlignment(
                    props.zigZagImageAlignment
                )} object-cover rounded-xl border-4 border-accent`}
            />
            <div className="flex flex-col justify-center items-start gap-4 sm:gap-8 border-x-4 border-transparent md:border-none">
                <div>
                    <div className={`${props.zigZagContentIconToggle ? "flex items-end gap-12" : ""}`}>
                        <div>
                            <BaseHeadline headlineType={3} label={props?.zigZagContentHeading} classProps="break-words sm:break-normal" />
                            <BaseSubheadline label={props?.zigZagContentSubHeading} classProps="pb-2" />
                        </div>
                        {props.zigZagContentIconToggle && (
                            <img
                                src={API + props.zigZagContentIcon?.url}
                                alt={props.zigZagContentIcon?.description || props.zigZagContentIcon?.name}
                                className="w-16 max-h-20 object-contain mb-4"
                            />
                        )}
                    </div>
                    <BaseRichtext content={props.zigZagContentText} />
                </div>
                <PrimaryButton
                    text={props.zigZagContentButtonText ?? ""}
                    onClick={() => {
                        if (props.zigZagContentButtonUrl?.includes("https://")) {
                            window.open(props.zigZagContentButtonUrl, "_blank")
                        } else {
                            navigate(props.zigZagContentButtonUrl ?? "/")
                        }
                    }}
                    active={props.zigZagContentButtonToggle}
                    classProps="!w-full sm:w-fit"
                />
            </div>
        </div>
    )
}
